<div class="content-heading">
    <div class="header-Container">
        <h3>Reporte de Certificacion Piezas por Envase</h3>
        <small>Reporte Web</small>
    </div>
</div>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-default">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Organizaci&oacute;n</label>
                                <select class="form-control" [(ngModel)]="organizationSelected"
                                        name="RegionNameOri" required [disabled]="working" title="Organización"
                                        (ngModelChange)="getRegion()">
                                    <!--<option [value]="0" selected>Todos</option>-->
                                    <option *ngFor="let unit of organizacionList" [value]="unit.UnitId">{{unit.UnitDescription}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Regi&oacute;n</label>
                                <select class="form-control" [(ngModel)]="regionSelected"
                                        name="RegionNameOri" required [disabled]="working" title="Región"
                                        (ngModelChange)="getNodes()">
                                    <option [value]=0 selected>TODOS</option>
                                    <option *ngFor="let unit of region" [value]="unit.UnitId">{{unit.UnitDescription}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Nodo Origen</label>
                                <ng-autocomplete
                                    [placeholder]="'Búsqueda'"
                                    [disabled]="working"
                                    [data]="nodesUser"
                                    [searchKeyword]="inputKeyword"
                                    [itemTemplate]="itemInputTemplate"
                                    [notFoundTemplate]="notFoundinputTemplate"
                                    [debounceTime]="600"
                                    [minQueryLength]="3"
                                    (selected)="nodeSelection(true)"
                                    (inputCleared)="clearOriginNode()"
                                    [(ngModel)]="OriginNode"
                                >
                                </ng-autocomplete>
                                <ng-template #itemInputTemplate let-item>
                                    <a [innerHTML]="item.UnitDescription"></a>
                                </ng-template>
                                <ng-template #notFoundinputTemplate let-notFound>
                                    <div [innerHTML]="'No se encontraron coincidencias'"></div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Fecha inicial</label>
                                <input type="date" class="form-control" [max]="today" [ngModel]="minDate | date:'yyyy-MM-dd'" (ngModelChange)="minDate=$event" required>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Fecha final</label>
                                <input type="date" class="form-control" [max]="today" [ngModel]="maxDate | date:'yyyy-MM-dd'" (ngModelChange)="maxDate=$event" required>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row mt-4 col-lg-12 col-md-12">
                            <div class="col col-md-12">
                                <button class="mr-1 btn btn-labeled btn-outline-success mb-2" (click)="download()" *ngIf="!downloading" [disabled]="working">
                                    <span class="btn-label">
                                        <i class="fa fa-file-excel" aria-hidden="true" style="font-size: 1.5em;"></i>
                                    </span>
                                    <span>Descargar reporte</span>
                                </button>
                                <button class="btn btn-labeled btn-outline-success mb-2" *ngIf="downloading" disabled>
                                    <span class="btn-label">
                                        <i class="fa fa-circle-notch fa-spin" style="font-size: 1.5em;"></i>
                                    </span>
                                    <span>Descargando</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>